import { type AuthTab } from '@view/auth/model'

export const authTexts: Record<AuthTab, AuthTabTexts> = {
  login: {
    subtitle: 'Войдите, чтобы продолжить',
    submit: 'Войти',
    callout: {
      title: 'Ещё нет учётной записи?',
      description: 'Создайте аккаунт за минуту',
      action: 'Зарегистрироваться',
    },
  },
  register: {
    subtitle: 'Зарегистрируйтесь, чтобы продолжить',
    submit: 'Зарегистрироваться',
    callout: {
      title: 'Уже есть учётная запись?',
      description: 'Войдите в свой аккаунт',
      action: 'Войти',
    },
  },
}

interface AuthTabTexts {
  subtitle: string
  submit: string
  callout: {
    title: string
    description: string
    action: string
  }
}
